import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import { DeleteOutline, Edit, GetApp } from "@material-ui/icons";
import { DictionaryConfigDbRow } from "../../../../types/config";
import { formatDatetimeYYYYMMDDHHMMSS } from "../../../../helpers";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tr: {
      width: "100%",
      border: "1px solid rgb(224,224,224)",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "none",
    },
    td: {
      width: "auto",
      padding: theme.spacing(2),
    },
    tdEmpty: {
      width: "100%",
      textAlign: "center",
      padding: theme.spacing(2),
    },
    iconButton: {
      color: theme.palette.text.primary,
    },
  })
);

interface Props {
  row?: DictionaryConfigDbRow | null;
  onEdit: () => any;
  onDelete: () => any;
}

/** 辞書設定テーブル表示行 */
export function DictionaryConfigRowRender(props: Props) {
  const classes = useStyles();

  const { row, onEdit, onDelete } = props;

  // ダウンロードアンカー
  const anchorRef = React.useRef<HTMLAnchorElement>(null);

  // 空行取得
  const getComponentEmpty = () => {
    return (
      <tr className={classes.tr}>
        <td className={classes.tdEmpty} colSpan={3}>
          <span>データがありません</span>
        </td>
      </tr>
    );
  };

  // 日時取得
  let strDate = "";
  if (row) {
    strDate = formatDatetimeYYYYMMDDHHMMSS(new Date(row.updated_at));
  }

  // 行取得
  const getComponentRow = () => {
    return (
      <tr className={classes.tr}>
        <td className={classes.td}>
          <span>{row?.name}</span>
        </td>
        <td className={classes.td}>
          <span>{strDate}</span>
        </td>
        <td>
          <div>
            {/* 編集ボタン */}
            <Tooltip title="編集">
              <IconButton className={classes.iconButton} onClick={onEdit}>
                <Edit />
              </IconButton>
            </Tooltip>
            {/* ダウンロードボタン */}
            <Tooltip title="ダウンロード">
              <IconButton
                className={classes.iconButton}
                onClick={() => {
                  if (anchorRef.current) {
                    anchorRef.current.click();
                  }
                }}
              >
                <GetApp />
              </IconButton>
            </Tooltip>
            {/* 削除ボタン */}
            <Tooltip title="削除">
              <IconButton className={classes.iconButton} onClick={onDelete}>
                <DeleteOutline />
              </IconButton>
            </Tooltip>
          </div>
          {/*
            ダウンロードボタン実体（非表示）

            download属性にファイル名を指定しても、
            ドメインが異なる場合はファイル名が変更されない
            [参照] https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes
          */}
          <a
            href={row?.file}
            download={row?.name}
            ref={anchorRef}
            style={{ display: "none" }}
          >
            {row?.file}
          </a>
        </td>
      </tr>
    );
  };

  //--------------------
  // コンポーネント
  return <>{row ? getComponentRow() : getComponentEmpty()}</>;
}
